export default function Footer() {
  return (
    <footer className="bg-white dark:bg-[#0a0a0a] text-gray-600 dark:text-gray-400 py-8 px-6 text-center mt-20 border-t border-[#0077cc] dark:border-[#0077cc]/50 transition-colors duration-300">
      <p className="mb-2 text-sm md:text-base">
        &copy; {new Date().getFullYear()}{" "}
        <span className="text-[#0077cc] dark:text-[#66ccff] font-semibold">Project Port</span>. All rights reserved.
      </p>
      <p className="text-xs md:text-sm">
        A{" "}
        <span className="text-[#0077cc] dark:text-[#66ccff] font-medium">
          Techverra Solutions
        </span>{" "}
        product |{" "}
        <a
          href="https://techverrasolutions.in"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#0077cc] hover:text-[#005fa3] dark:hover:text-[#66ccff] underline transition"
        >
          techverrasolutions.in
        </a>
      </p>
    </footer>
  );
}
